import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const REJECT_ONE_DEPOSIT = gql`
    mutation(
        $id: String!
    ) {
        rejectOneTransaction (id: $id) {
            ...TransactionInfo
        }
    }
    ${TransactionFragment}
`;